import { useEffect, useState } from 'react';
import { platformSettingsAPI, type DisplaySettingsDeliveryGrain } from '../lib/api';

/** A PO-line-grain site of a mixed-grain group view. */
export interface GroupLineSite {
  id: number;
  name: string;
}

/**
 * The PO-line-grain sites of the group in view when that group mixes delivery
 * grains (display settings ``group_po_line_sites``); empty for a single site,
 * a single-grain group, or on failure. Re-read on every view switch.
 *
 * @param viewKey - the view-context key (``useView().viewKey``)
 * @param enabled - false skips the request (e.g. supplier users)
 * @returns the sites, sorted by name
 */
export function useGroupLineSites(viewKey: string, enabled: boolean): GroupLineSite[] {
  const [sites, setSites] = useState<GroupLineSite[]>([]);
  useEffect(() => {
    if (!enabled) { setSites([]); return; }
    let cancelled = false;
    platformSettingsAPI.getDisplaySettings()
      .then((res) => { if (!cancelled) setSites((res.data as unknown as DisplaySettingsDeliveryGrain).group_po_line_sites ?? []); })
      .catch((err: unknown) => {
        console.error('Failed to load group sites:', err);
        if (!cancelled) setSites([]);
      });
    return () => { cancelled = true; };
  }, [viewKey, enabled]);
  return sites;
}
